 <template lang="pug">
  validation-observer(ref='validation' tag='form')
    div
      h4 Função por Equipe (Por Processo)
      app-modal-visualizar-completo(
        v-if="showModalVisualizarProcesso && idProcesso !== null",
        @closeModal="showModalVisualizarProcesso = false",
        :idProcesso='idProcesso',
        :protocolo="protocolo",
        :numeroProcesso="numeroProcesso",
        :tipo="tipoProcesso"
      )
      div(v-if="grupos && Object.keys(grupos).length === 0")
        p Não há processos para serem exibidos
      div(v-else)
        el-collapse(:accordion="true", v-for="(subProcessos, numeroDoProcesso) in grupos", :key="numeroDoProcesso", v-model="ativarTodas")
          el-collapse-item(:key="numeroDoProcesso", :name='numeroDoProcesso')
            template(slot="title")
              span.titulo Processo {{numeroDoProcesso}}: {{ subProcessos[0].nomeRazaoSocialInteressado || subProcessos[0].processo.nomeRazaoSocialInteressado }}
            div(:accordion="true")
              el-row
                el-card
                  el-col.container-input
                    validation-provider(rules="required", v-slot="{ errors }")
                      app-label(
                        label="Vincular para: ",
                        :required="true"
                      )
                      el-radio-group(v-model="radio[numeroDoProcesso]", @change="setRadio($event, numeroDoProcesso, subProcessos)", :disabled="isDisabledRadio(subProcessos)", :class="{'error-radio' : errors.length}" )
                        el-radio(label="FISCALIZADOR") Fiscalizador
                        el-radio(label="GEOMENSOR") Geomensor
                      span.help.erro {{ errors[0] }}
                      el-row.margin
                        el-col(:span="12", v-for="(subProcessoItem, numeroSubProcesso) in subProcessos", :key="numeroSubProcesso")
                          div(v-if="exibirSelectPorFuncao(subProcessoItem)")
                            validation-provider(:rules="subProcessoFinalizado(subProcessoItem) ? '' :'required'", v-slot="{ errors }")
                              app-label(
                                :label="getFuncao(subProcessoItem.funcao)",
                                :required="!subProcessoFinalizado(subProcessoItem)"
                              )
                              el-select.input.seletor(:value="getUsuario(subProcessoItem.usuario.id)", @input="setUsuario(subProcessoItem, $event)", :disabled="subProcessoFinalizado(subProcessoItem)")
                                el-option(v-for='usuario in analistasSelecionados' :key='usuario.id' :label='usuario.nome' :value='usuario.id')
                              span.help.erro {{ errors[0] }}
                    div.button-visualizar
                      el-button(@click="visualizarProcesso(subProcessos[0])" type="text")
                        i.fa.fa-eye
                        | &nbsp Visualizar Processo
</template>

<script>
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import { funcoes } from '@/constants/selects'

export default {
  components: {
    AppLabel,
    AppModalVisualizarCompleto
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    numero: {
      required: true
    },
    usuario: {
      required: true
    },
    ordemServico: {
      required: true
    },
    analistas: {
      required: true
    }
  },

  async mounted () {
    await this.getSubProcessoSelecionados().then(res => {
      this.processos = res
    })
    this.ordemServico.processos = this.processos
    this.initSubProcessoAgrupadoPorNumero()
  },

  data () {
    return {
      tipos: ['VISTORIADOR', 'ADMINISTRATIVO'],
      numeroExistente: false,
      radio: {
      },
      documentos: [],
      numeroProcesso: null,
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      showModalVisualizarProcesso: false,
      processos: [],
      grupos: null
    }
  },

  computed: {

    analistasSelecionados () {
      return this.analistas.filter(a => a.selecionado)
    },
    ativarTodas () {
      return this.processos.map((item) => item.numero)
    }
  },

  watch: {
    processos: function (val, oldVal) {
      this.grupos = _.groupBy(val, 'numero') // eslint-disable-line
    }
  },

  methods: {
    ...mapActions({
      addSubProcessoSelecionado: 'ordemServico/addSubProcessoSelecionado',
      getSubProcessoSelecionados: 'ordemServico/getSubProcessoSelecionados',
      setUsuarioSubProcesso: 'ordemServico/setUsuarioSubProcesso',
      setUsuarioNullSubProcesso: 'ordemServico/setUsuarioNullSubProcesso'
    }),

    initSubProcessoAgrupadoPorNumero () {
      this.grupos = _.groupBy(this.ordemServico.processos, 'numero') // eslint-disable-line
      _.mapValues(this.grupos, (grupo, numero) => { // eslint-disable-line
        if (this.radio[numero] === undefined || !this.radio[numero] || this.radio[numero] === '' || this.radio[numero] === 'VISTORIADOR') {
          this.radio[numero] = this.getTipo(numero)
        }
      })
    },

    isDisabledRadio (subProcessos) {
      let variavelControle = 0

      subProcessos.forEach(s => {
        if ((s.status !== null && this.subProcessoFinalizado(s) && (s.funcao === 'GEOMENSOR' || s.funcao === 'FISCALIZADOR')) || s.tipo === 'REURB-S') {
          variavelControle += 1
        }
      })
      return variavelControle > 0 || subProcessos?.find(p => p && p.processo && p.processo.somenteVistoria)
    },

    subProcessoFinalizado (subProcessoItem) {
      return (subProcessoItem?.status === 'FINALIZADO' || (subProcessoItem?.processo?.somenteVistoria && subProcessoItem?.funcao !== 'VISTORIADOR'))
    },

    getUsuario (idUsuario) {
      return (this.analistasSelecionados.find(a => a.id === idUsuario) !== undefined) ? idUsuario : null
    },

    async setUsuario (subProcessoItem, usuario) {
      await this.setUsuarioSubProcesso({subProcesso: subProcessoItem, usuario: usuario})
      await this.getSubProcessoSelecionados().then(res => { this.processos = res })
      this.ordemServico.processos = this.processos
    },

    async setRadio (tipo, numeroProcesso, subProcessos) {
      this.radio[numeroProcesso] = tipo
      this.$forceUpdate()
      await this.setUsuarioNullSubProcesso({numeroProcesso: numeroProcesso})
      this.gerarSubProcesso(subProcessos, tipo)
    },

    getTipo (numero) {
      const processo = this.processos.filter(p => (p.numero === numero))
      const filtro = processo.find(p => (p.funcao === 'FISCALIZADOR' || p.funcao === 'GEOMENSOR') && p.id !== null)
      const somenteVistoria = processo.find(p => p.processo && p.processo.somenteVistoria && p.id !== null)
      if (somenteVistoria) {
        return 'FISCALIZADOR'
      }

      return filtro ? filtro.funcao : null
    },

    async gerarSubProcesso (subProcessos, tipo) {
      if (!subProcessos.find(s => s.funcao === tipo)) {
        var novo = _.cloneDeep(subProcessos[0]) // eslint-disable-line
        novo.funcao = tipo
        novo.usuario = {
          id: null
        }
        novo.id = null
        await this.addSubProcessoSelecionado({subProcesso: novo})
      }
      this.$nextTick(async () => {
        await this.getSubProcessoSelecionados().then(res => { this.processos = res })
        this.ordemServico.processos = this.processos
      })
    },

    exibirSelectPorFuncao (subProcessoItem) {
      const tipoCodigo = subProcessoItem.processo.tipoCodigo || subProcessoItem.tipoCodigo || subProcessoItem.processo.tipo.nome || subProcessoItem.processo.tipo
      if (subProcessoItem.funcao === 'ADMINISTRATIVO' && tipoCodigo !== 'TEQ' && tipoCodigo !== 'PEAEX') {
        return false
      }
      return this.tipos.filter(p => p === subProcessoItem.funcao).length > 0 ||
        (subProcessoItem.funcao === this.radio[subProcessoItem.numero])
    },

    showSelectFuncao (subProcessoItem) {
      return subProcessoItem.funcao === this.radio[subProcessoItem.numero] || subProcessoItem.funcao === 'VISTORIADOR'
    },

    getFuncao (codigo) {
      const funcao = funcoes.find(c => c.codigo === codigo)
      return funcao ? funcao.nome : codigo
    },
    visualizarProcesso (item) {
      if (item.numeroProtocolo == null) {
        this.numeroProcesso = item.processo.numeroProcesso
        this.idProcesso = item.processo.id
        this.protocolo = item.processo.numeroProtocolo
        this.tipoProcesso = item.processo.tipoCodigo
      } else {
        this.numeroProcesso = item.numero
        this.idProcesso = item.id
        this.protocolo = item.numeroProtocolo
        this.tipoProcesso = item.tipoCodigo
      }
      this.showModalVisualizarProcesso = true
    },

    async checkValidacao () {
      const valido = await this.$refs.validation.validate()

      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }

      return true
    }
  }

}
</script>
<style scoped>
.button-visualizar {
  width: 100%;
  height: 40px;
}

.margin {
  margin-top: 25px;
}

.seletor {
  width: 98%;
}

.titulo {
  color: #909399;
  font-size: 16px;
}

.container-os {
  min-height: 89vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/ordemServico/DadosEquipe.vue